module.exports = __webpack_public_path__ + "img/PAI_Landing-Page_Mobile_20_16.22ff16f8.jpg";